import { render, staticRenderFns } from "./FeatureBox.vue?vue&type=template&id=56822819&scoped=true"
var script = {}
import style0 from "./FeatureBox.vue?vue&type=style&index=0&id=56822819&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56822819",
  null
  
)

export default component.exports